const Collapsible = ({ collapsed, children }) => {
  if (!collapsed) {
    return <div>{children}</div>;
  }
  return <div />;
};

export default Collapsible;
